import { useEffect } from 'react'
import useAuthStore from '@/stores/authStore'

/**
 * useAuth — primary auth hook.
 * Initializes the auth listener on first mount (app-level).
 * Use this in App.jsx once. Everywhere else, just import useAuthStore directly.
 */
export function useAuthInit() {
  const initialize = useAuthStore((s) => s.initialize)

  useEffect(() => {
    const cleanup = initialize()
    return cleanup
  }, [initialize])
}

/**
 * useAuth — convenience destructure for common auth values.
 * Use this in page-level components.
 */
export function useAuth() {
  const user        = useAuthStore((s) => s.user)
  const profile     = useAuthStore((s) => s.profile)
  const loading     = useAuthStore((s) => s.loading)
  const authLoading = useAuthStore((s) => s.authLoading)
  const error       = useAuthStore((s) => s.error)
  const isCustomer  = useAuthStore((s) => s.isCustomer)
  const isWorker    = useAuthStore((s) => s.isWorker)
  const isAdmin     = useAuthStore((s) => s.isAdmin)
  const signOut     = useAuthStore((s) => s.signOut)
  const clearError  = useAuthStore((s) => s.clearError)

  return {
    user,
    profile,
    loading,
    authLoading,
    error,
    isAuthenticated: !!user,
    isCustomer: isCustomer(),
    isWorker:   isWorker(),
    isAdmin:    isAdmin(),
    role:       profile?.role ?? null,
    signOut,
    clearError,
  }
}

export default useAuth
